module.exports = __webpack_public_path__ + "media/images/pepsi_digin_brunch_lv/treat-white-bg-b05449859e3a64c0eca75ba50451153b.png";